import { render } from "./PendingNotifications.vue?vue&type=template&id=47e9cd0c&scoped=true"
import script from "./PendingNotifications.vue?vue&type=script&lang=js"
export * from "./PendingNotifications.vue?vue&type=script&lang=js"

import "./PendingNotifications.vue?vue&type=style&index=0&id=47e9cd0c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e9cd0c"]])

export default __exports__